module.exports = __webpack_public_path__ + "img/mondsee_kapelle.75bd1061.jpg";